import { EnvironmentService } from '@angular-monorepo/environment';
import { Injectable } from '@angular/core';
import {  Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DocumentType, PaymentDetails, ResponseConfirmOperation, StatusTransfiya } from './daviplata.interface';
import { encodeApiPathSegment } from '@core/utils/api-path.utils';

@Injectable({
  providedIn: 'root'
})
export class DaviplataService {

  private get baseUrl(): string {
    return this.environmentService.env.apiConfig.payinCheckoutBackendUrl;
  }

  private operationPath(idTransaction: string): string {
    return encodeApiPathSegment(idTransaction);
  }

  constructor(
    private environmentService: EnvironmentService,
    private http: HttpClient,
  ) { }

  findDocumentByCountry(): Observable<DocumentType[]> {
    return this.http.get<DocumentType[]>(`${this.baseUrl}common/master-parameters/api/find/documentCountry/COL?documentType=N`);
  }

  initOperation(idTransaction:string, body:any,verification:string):  Observable<ResponseConfirmOperation>{
    const headers = new HttpHeaders({
      'verification':  verification
    });
    return this.http.post<ResponseConfirmOperation>(`${this.baseUrl}processor/daviplata/operation/init/${this.operationPath(idTransaction)}`, body, { headers });
  }

  confirmOperation(idTransaction:string, body:any,verification:string): Observable<ResponseConfirmOperation>{
    const headers = new HttpHeaders({
      'verification':  verification
    });
    return this.http.post<ResponseConfirmOperation>(`${this.baseUrl}processor/daviplata/operation/confirm/${this.operationPath(idTransaction)}`, body, { headers });
  }

  expirateOperation(idTransaction:string,verification:string): Observable<ResponseConfirmOperation>{
    const headers = new HttpHeaders({
      'verification':  verification
    });
    return this.http.post<ResponseConfirmOperation>(`${this.baseUrl}processor/daviplata/operation/expire/${this.operationPath(idTransaction)}`, null, { headers });
  }

  getPaymentDetails(idTransaction:string,verification:string) : Observable<PaymentDetails>{
    const headers = new HttpHeaders({
      'verification':  verification
    });

    return this.http.post<PaymentDetails>(`${this.baseUrl}common/operation/find/${this.operationPath(idTransaction)}`, {}, { headers });
  }

  payTransfiya(id: number, phoneNumber: string, verification: string) : Observable<void> {
    const headers = new HttpHeaders({
      'verification':  verification
    });
    const body = {
      phoneNumber,
      id
    };
    return this.http.post<void>(`${this.baseUrl}common/operation/transfiya/process/`, body, { headers });
  }

  getStatusTransfiya(transactionId: string, verification: string) : Observable<StatusTransfiya> {
    const headers = new HttpHeaders({
      'verification':  verification
    });
    return this.http.get<StatusTransfiya>(`${this.baseUrl}common/operation/transfiya/get-status/${this.operationPath(transactionId)}`, { headers });
  }
}
